import {setStore, getStore, systemInfoByIP} from './index'

export const getApiUrl = () => {
  return systemInfoByIP().envAPI
}

export const getApiUrlKey = () => {
  console.log(systemInfoByIP())
  return systemInfoByIP().env
}

// 结合登录部分的选择环境使用
export const setApiUrlKey = (key) => {
  console.log('key',key)
  setStore('apiUrl', key, 24 * 60 * 60 * 7)
}



// WEBPACK FOOTER //
// ./src/utils/apiUrlConfig.js